import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptionsDynamic, TQueryOptionsDynamicKey } from '@kurtosys/types/query/options/index.js';

import { commonUtils } from '../../common/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class DynamicQuery extends BaseQuery<IQueryOptionsDynamic> {
	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsDynamic {
		const { key, keyQuery, options = {} } = this.queryOptions;
		return {
			keyQuery,
			key: key as TQueryOptionsDynamicKey,
			...(options.dynamic || {}),
		};
	}
	getRawValue<T = any>(): T {
		const { key } = this.options;
		let response: any;
		switch (key) {
			case 'date':
				response = commonUtils.getUTCDateString();
				break;
			case 'year':
				response = commonUtils.getUTCFullYear();
				break;
			case 'user-agent':
				response = navigator && navigator.userAgent;
				break;
			case 'isoDateTime':
				response = new Date().toISOString();
				break;
		}
		return response;
	}
}
